// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"aed9e481","513":"38031b82","703":"fce9a2e7","787":"80a98667"}[chunkId] + ".chunk.js";
};